<template>
  <div id="page-user-edit">
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{ name: 'page-user-list' }" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="user_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Profile" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <profile-tab class="mt-4" :data="user_data" />
            </div>
          </vs-tab>
          <vs-tab label="Security" icon-pack="feather" icon="icon-shield">
            <div class="tab-text">
              <profil-security class="mt-4" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import ProfileTab     from './ProfilTab.vue'
import ProfilSecurity from './ProfilSecurity.vue'

// Store Module
import moduleOperationList from '@/store/operation/moduleOperationList.js'

export default {
  components: {
    ProfileTab,
    ProfilSecurity
  },
  data () {
    return {
      user_data: null,
      user_not_found: false,
      // ?tab=security on the URL lands the user directly on the Security tab
      // (used by the post-login 2FA prompts pointing here from the dashboards).
      activeTab: this.$route.query.tab === 'security' ? 1 : 0
    }
  },
  methods: {
    fetch_user_data (userId) {
      if (userId) {
        this.$store.dispatch('operationList/fetchOperation', userId)
          .then(res => { this.user_data = res.data })
          .catch(err => {
            if (err.response.status === 404) {
              this.user_not_found = true
              return
            }
            console.error(err)
          })
      } else {
        this.user_data = {}
      }
    }
  },
  created () {
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule('operationList', moduleOperationList)
      moduleOperationList.isRegistered = true
    }
    this.fetch_user_data(this.$route.params.userId)
  }
}
</script>
